import { Link } from 'react-router-dom'
import type { AssessmentListItem, SubmissionStatus } from '@assessments/shared'
import { Button } from '@/components/ui/button'
import { SUBMISSION_STATUS_EDITOR_ACTION } from './submissionStatus.js'

export function actionLabel(status: SubmissionStatus, canEdit: boolean): string {
  return canEdit ? SUBMISSION_STATUS_EDITOR_ACTION[status] : 'View'
}

/**
 * The card's single action. Every status lands on the overview, which gates entry
 * itself (welcome, then the T&C prerequisite, then the content). Actions that start or
 * resume work are filled; a read-only "View" is outlined.
 */
export function AssessmentCardAction({
  item,
  canEdit,
}: {
  item: AssessmentListItem
  canEdit: boolean
}) {
  const label = actionLabel(item.status, canEdit)
  return (
    <Button
      asChild
      size="lg"
      variant={label === 'View' ? 'primaryOutline' : 'default'}
      className="min-w-[200px] font-semibold"
    >
      <Link to={`/assessments/${item.organizationSurveyId}`} aria-label={`${label} ${item.title}`}>
        {label}
      </Link>
    </Button>
  )
}
